export function debounce<TParams>(fn: (...params: TParams[]) => void, time: number) {
  let timerId: ReturnType<typeof setTimeout> | undefined;

  const cancel = () => {
    if (timerId) {
      clearTimeout(timerId);
      timerId = undefined;
    }
  };
  // eslint-disable-next-line func-names
  const debouncedFn = (...args: TParams[]) => {
    cancel();
    timerId = setTimeout(() => fn(...args), time);
  };
  return {
    cancel,
    debouncedFn,
    isActive: () => !!timerId,
  };
}
